import * as React from "react";
import { EditorContextProvider } from "ui/context/EditorContext";
import EditorPage from "ui/views/Editor";

const EditorPageContainer: React.FC = () => (
    <EditorContextProvider>
        <EditorPage />
    </EditorContextProvider>
);

export default EditorPageContainer;
